import { ProgramTypes } from 'legacy/lut/classes/models/ProgramTypes'
import { useCallback } from 'react'

import { Flex } from 'core-components/library/flex'

import { OfferingIcon } from './components/offeringIcon/OfferingIcon'

interface IOfferingWithIconProps {
  offering: ProgramTypes
  className?: string
  onClick?: (offering: string) => void
}

export const OfferingWithIcon = ({ offering, className, onClick }: IOfferingWithIconProps) => {
  const handleClick = useCallback(() => {
    if (onClick) {
      onClick(offering)
    }
  }, [offering, onClick])

  return (
    <div onClick={handleClick}>
      <Flex gap={'sm'} alignItems={'center'} className={className}>
        <OfferingIcon offering={offering} />
        <div>{offering}</div>
      </Flex>
    </div>
  )
}
